
        import {css} from 'lit-element';   
        export default css`:host .otp-input{display:flex;flex-direction:row}`;
    